module.exports = __webpack_public_path__ + "static/media/3-b.18b48052.png";